<template>
  <div>тут будет список договоров</div>
</template>
<script>
export default {}
</script>
<style></style>
